<svg #gauge [attr.percent]='percent'>
    <circle cx='70' cy='70' r='64'></circle>
    <circle cx='70' cy='70' r='64'></circle>

    <text class="value" x="70" y="75" text-anchor="middle">
        <tspan>{{flooredValue}}%</tspan>
    </text>

    <text class="caption" x="70" y="100" text-anchor="middle">
        <tspan>Takt</tspan>
    </text>
</svg>